import React from "react";
import TextArea from "../textArea/TextArea";
import {LightingTextWrapper} from "./LightingTextStyled";

type IProps = {
    showPopup?: boolean;
}

const CareerExpressConsentText = ({
                                      showPopup = false
                                  }: IProps) => {
    return (
        <LightingTextWrapper className={showPopup ? 'popup-wrapper' : undefined}>
            <TextArea>
                <h2 className={showPopup ? 'popup-wrapper-title' : undefined}>Kişisel Verilerin Korunması</h2>
                <h3 style={{marginTop: 0}}>
                    Çalışan Adayı Açık Rıza Metni ve Beyanı
                </h3>
                <p>
                    6698 sayılı Kişisel Verilerin Korunması Kanunu'na göre sizinle ilgili bazı kişisel verilerin, veri
                    sorumlusu olan Panjur Bilişim ve Danışmanlık Hizmetleri Ticaret A.Ş. <span
                    style={{fontWeight: 'bold'}}>(Panjur Bilişim)</span>, tarafından
                    işlenebilmesi için açık rızanız gerekmektedir.
                </p>

                <h3 style={{marginTop: 0}}>
                    Açık Rızanıza İstinaden İşlenecek Kişisel Verileriniz ve İşlenme Amaçları
                </h3>
                <p>
                    Firmamıza iş başvurusu yapmanız sırasında ilettiğiniz;
                </p>
                <ul>
                    <li style={{listStyle: 'disc'}}>
                        Kimlik, İletişim, Adres, Çalışmak İstediğiniz pozisyon bilgileri, başvuru ile ilgili
                        açıklamalarınız ile Özgeçmişinizde yer alan Öğrenim Bilgileriniz, başvurduğunuz pozisyona
                        ilişkin beceriler, Mesleki deneyim bilgileriniz, Özgeçmişinizde yer alan diğer bilgileriniz ve
                        varsa cover letter içeriğiniz,
                    </li>
                </ul>
                <p>
                    <span
                        style={{fontWeight: 'bold'}}>Çalışan Adaylarının Başvuru Süreçlerinin Yürütülmesi</span> amacıyla
                    KVKK Md.5/1’de öngörülen açık rızanıza
                    istinaden işlenecektir.
                </p>
                <p>
                    İşlenmesine açık rıza verdiğiniz kişisel veriler başvurunuzun reddedilmesi halinde bir süre saklanıp
                    imha edilecek olup, işe kabulünüz halinde özlük dosyanızda saklanmaya devam edecektir.
                </p>
            </TextArea>
        </LightingTextWrapper>
    )

}

export default CareerExpressConsentText;